"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlicePrimaryContent = exports.SlicePrimaryLegacy = exports.SlicePrimaryContent = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const customtypes_1 = require("../../../../customtypes");
const GroupContent_1 = require("../../GroupContent");
const nestable_1 = require("../../nestable");
exports.SlicePrimaryContent = t.union([nestable_1.NestableContent, GroupContent_1.GroupContent]);
const SlicePrimaryLegacy = (ctx) => {
    const groupCodec = (0, GroupContent_1.GroupLegacy)(ctx);
    const nestableCodec = (0, nestable_1.NestableLegacy)(ctx);
    return {
        decode(value) {
            if (ctx.fieldType === customtypes_1.GroupFieldType) {
                return groupCodec.decode(value);
            }
            return nestableCodec.decode(value);
        },
        encode(value) {
            if ((0, GroupContent_1.isGroupContent)(value)) {
                return groupCodec.encode(value);
            }
            return nestableCodec.encode(value);
        },
    };
};
exports.SlicePrimaryLegacy = SlicePrimaryLegacy;
const isSlicePrimaryContent = (u) => (0, nestable_1.isNestableContent)(u) || (0, GroupContent_1.isGroupContent)(u);
exports.isSlicePrimaryContent = isSlicePrimaryContent;
